/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const InventoryStatus = {
    IN_STOCK: 'IN_STOCK',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    LISTING_RECOMMENDATION: 'LISTING_RECOMMENDATION'
};
